import React, { useEffect, useState } from 'react';
import HeartIcon from '@tradera/blueprint/theme/icons2/heart.svg?jsx';
import HeartFilledIcon from '@tradera/blueprint/theme/icons2/heart-fill.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import {
    closeCategoryDropdownMenu,
    closeProfileMenu,
    closeNotificationsSideSheet,
    closeWishListSideSheet,
    openWishListSideSheet
} from 'tradera/state/ui/reducer';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import { classNames } from 'tradera/utils/class-names';

const WishlistLinkMemo = () => {
    const dispatch = useAppDispatch();

    const { isOpen } = useAppSelector((state) => state.ui.wishListSideSheet);

    const wishListAddedCount = useAppSelector(
        (state) => state.items.wishListAddedCount
    );

    const [prevNumWishListItemIds, setPrevNumWishListItemIds] = useState<
        number | null
    >(null);
    const [heartBlink, setHeartBlink] = useState(false);

    useEffect(() => {
        if (
            prevNumWishListItemIds !== null &&
            prevNumWishListItemIds < wishListAddedCount
        ) {
            setHeartBlink(true);
            setTimeout(() => setHeartBlink(false), 600);
        }

        setPrevNumWishListItemIds(wishListAddedCount);
    }, [wishListAddedCount, prevNumWishListItemIds]);

    const handleOnClick = () => {
        if (isOpen) {
            dispatch(closeWishListSideSheet());
        } else {
            dispatch(closeCategoryDropdownMenu());
            dispatch(closeProfileMenu());
            dispatch(closeNotificationsSideSheet());

            dispatch(openWishListSideSheet());
        }
    };

    return (
        <div>
            <Button
                className={classNames('slim-header__button', {
                    active: isOpen
                })}
                rel="nofollow"
                data-ga-category="Top navigation"
                data-ga-action="Watchlist menu"
                data-ga-label="Link - Wishlist from NavBar"
                data-nav-wishlist
                onClick={handleOnClick}
                theme="text">
                <div className="position-relative">
                    <HeartIcon className="icon icon-md" />
                    {heartBlink && (
                        <HeartFilledIcon className="position-absolute icon icon-md icon-danger stroke-black fade-in-out" />
                    )}
                </div>
            </Button>
        </div>
    );
};

export const WishlistLink = React.memo(WishlistLinkMemo);
